import { render, staticRenderFns } from "./ModalShipments.vue?vue&type=template&id=735e6df2&lang=pug&"
import script from "./ModalShipments.vue?vue&type=script&lang=js&"
export * from "./ModalShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports